import NotFound from '@/pages/notFound';
import withoutAside from "./modules/appPages/withoutAside";

const modulesFiles = require.context('./modules', true, /\.js$/)
let map = {};//用状态机的模式
modulesFiles.keys().reduce((modules, modulePath) => {
  let list = [];
  const file = modulesFiles(modulePath);
  const name = modulePath.split("/")[1].split(".")[0];
  list = [
    ...file.default
  ]
  map[name] = list;
}, {})

const routerConfig = [
  { path: '*', component: NotFound },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('@/pages/login/main.vue')
  },
  //个人写稿(图文)
  {
    path: '/scriptWrite', component: () => import('@/pages/newScript/index.vue')
  },
  //个人写稿(视频)
  {
    path: '/videoWrite', component: () => import('@/pages/newScript/video.vue')
  },
  //个人写稿(图集)
  {
    path: '/graphWrite', component: () => import('@/pages/newScript/graph.vue')
  },
  //帖子
  {
    path: '/post', component: () => import('@/pages/newScript/post.vue')
  },
  //剧集
  {
    path: '/episode', component: () => import('@/pages/newScript/episode.vue')
  },
  //稿件详情页
  {
    path: '/scriptDetail', component: () => import('@/pages/scriptDetail/index.vue')
  },
  //优质顶端号榜单
  {
    path: '/rank', component: () => import('@/pages/rank/index.vue')
  },
  //话题详情页
  {
    path: '/theme', component: () => import('@/pages/scriptDetail/theme.vue')
  },
  // 没有侧边栏的页面路由
  ...withoutAside,
  //用文件名获取对应路由
  ...map.index,
  ...map.tools,
  ...map.app,
  ...map.personalScript,
  ...map.rights,
  ...map.govAffairs,
  ...map.enterprise,
  ...map.helpCenter,
  ...map.comment
];

export default routerConfig;
